import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de proyectos
 * Maneja todas las operaciones CRUD relacionadas con proyectos
 * 
 * NOTA: Los endpoints de proyectos ahora usan Python (FastAPI)
 */
export const proyectoApi = {
  /**
   * Obtiene todos los proyectos del usuario autenticado o un proyecto específico
   * @param {number|null} id - ID del proyecto (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getAll: (id = null) => {
    const endpoint = id ? `/proyectos/${id}` : '/proyectos';
    // Usar Python API para proyectos
    return pythonApiClient.get(endpoint);
  },

  /**
   * Obtiene un proyecto por ID
   * @param {number} id - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    // Usar Python API para proyectos
    return pythonApiClient.get(`/proyectos/${id}`);
  },

  /**
   * Crea un nuevo proyecto
   * @param {Object} data - Datos del proyecto
   * @param {string} data.nombre - Nombre del proyecto
   * @param {string} data.pais - País del proyecto
   * @param {string} data.departamento - Departamento del proyecto
   * @param {string} data.provincia - Provincia del proyecto
   * @param {string} data.distrito - Distrito del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    // Usar Python API para proyectos
    return pythonApiClient.post('/proyectos', data);
  },

  /**
   * Actualiza un proyecto existente
   * @param {number} id - ID del proyecto
   * @param {Object} data - Datos actualizados del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    // Usar Python API para proyectos
    return pythonApiClient.put(`/proyectos/${id}`, data);
  },

  /**
   * Elimina un proyecto
   * @param {number} id - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    // Usar Python API para proyectos
    return pythonApiClient.delete(`/proyectos/${id}`);
  },

  /**
   * Obtiene proyectos asociados a un usuario
   * @param {number} userId - ID del usuario
   * @returns {Promise} - Respuesta de la API
   */
  getByUser: (userId) => {
    // Usar Python API - obtener proyectos del usuario
    return pythonApiClient.get(`/mantenimientos/usuarios/${userId}/proyectos`);
  },

  /**
   * Obtiene comedores de un proyecto
   * @param {number} id - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getComedores: (id) => {
    // Usar Python API para proyectos
    return pythonApiClient.get(`/proyectos/${id}/comedores`);
  },

  /**
   * Obtiene turnos de un proyecto
   * @param {number} id - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getTurnos: (id) => {
    // Usar Python API para proyectos
    return pythonApiClient.get(`/proyectos/${id}/turnos`);
  },

  /**
   * Obtiene proyectos para formularios según la sesión del usuario
   * - Si proyecto_id es null o -1 (corporativo): devuelve todos los proyectos del usuario
   * - Si proyecto_id tiene un valor válido: devuelve solo ese proyecto
   * @param {number|null} proyecto_id - ID del proyecto en sesión (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getParaFormulario: (proyecto_id = null) => {
    const params = proyecto_id !== null && proyecto_id !== undefined 
      ? `?proyecto_id=${proyecto_id}` 
      : '';
    return pythonApiClient.get(`/proyectos/para-formulario${params}`);
  }
};

export default proyectoApi;
